import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import {
	ContentContainer,
	TitleHeader,
	TableLoading,

} from "../components/UiComponents";
import {
	CourseHeader,
	CourseWrapper,
} from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";
import { format } from "date-fns";

const IncidentsWitnessedPage = () => {
	const { dispatch, api, state } = useAppContext();
	const isOffline = state.offline;
	useDocumentTitle("Incidents Witnessed");
	const [loading, setLoading] = useState(true);
	let course = api.getCurrentCourse();

	useEffect(() => {
		fetchData();
	}, []);

	async function fetchData() {
		if (isOffline) {
			setLoading(false);
			return;
		}
		const { data } = await api.fetchData(
			`/courses/${course.id}/incidents`
		);

		if (data?.incidents) {
			dispatch({
				type: "SET_COURSE_INCIDENTS",
				payload: {
					incidents: data.incidents,
					course_id: course.id,
				},
			});
			setLoading(false);
		} else {
			setLoading(false);
		}
	}

	return (
		<div className="written-assessments-page">
			<CourseHeader />
			<ContentContainer classes="mb-4">
				<CourseWrapper>
					<TitleHeader title={`Incidents Witnessed`} />
					<div className="written-assessments">
						{loading ? (
							<TableLoading rows={5} />
						) : (
							<>
								{course.incidents.length === 0 ? (
									<div className="written-assessments__empty">
										<p>No incidents reported yet.</p>
									</div>
								) : (
									<>
										<Incidents incidents={course.incidents} />
									</>
								)}
							</>
						)}
					</div>
				</CourseWrapper>
			</ContentContainer>
		</div>
	);
};

const Incidents = ({ incidents }) => {
	if (incidents.length === 0) {
		return null;
	}
	return (
		<table className="table table-striped responsive-table students-table">
			<thead>
				<tr>
					<th>Date</th>
					<th>Person</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{incidents.map((incident) => (
					<IncidentsTableRow incident={incident} key={incident.id} />
				))}
			</tbody>
		</table>
	);
};

const IncidentsTableRow = ({ incident }) => {
	const { state, api } = useAppContext();
	const isOffline = state.offline;
	const course = api.getCurrentCourse();

	let date = new Date(incident.date_of_incident);
	let formattedDate = format(date, 'dd/MM/yyyy');
	let answers = incident.answers;
	let person = ''
	if (answers) {
		// Loop answers and find the one with the key 'name_of_injured_person'
		for (let key in answers) {
			if (key === 'name_of_injured_person') {
				person = answers[key];
				break;
			}
		}
	}

	return (
		<tr>
			<td>
				{formattedDate}
			</td>
			<td>{person}</td>
			<td className="text-right">
				<Link
					to={`/courses/${course.id}/incidents-witnessed/${incident.id}`}
					className="btn btn-primary btn-sm"
					style={isOffline ? { pointerEvents: "none", opacity: .7 } : {}}
				>
					Edit Incident
				</Link>
			</td>
		</tr>
	);
};

export default IncidentsWitnessedPage;
